module.exports = __webpack_public_path__ + "static/media/ChartBar.f6b4d2e5.svg";